import * as React from "react"
import { Drawer, CircularProgress, CardText, Card, CardHeader, Chip } from "material-ui"
import autobind from "class-autobind"
import * as api from "../../api"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import MessageCenterStore from "../../stores/MessageCenterStore"
import { IMessageGroupDocument, IMessageGroupSend } from "../../models/documents/MessageGroupDocument"
import MessageCenterActions from "../../components/message_center/MessageCenterActions"
import MessageCenterNewMessageDialog from "../../components/message_center/MessageCenterNewMessageDialog"
import { IMessageGroupMemberSummary } from "../../models/documents/MessageGroupDocument"
import MessageCenterGroupsTable from "../../components/message_center/MessageCenterGroupsTable"

interface IState {
	loading: boolean
	openAddEdit: boolean
	groups: IMessageGroupDocument[]
	newMessageOpen: boolean
	members: IMessageGroupMemberSummary[]
	memberExpanded: boolean
}

interface IProps {
	open: boolean
	handleClose(): void
}

export default class MessageCenter extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			openAddEdit: false,
			groups: [],
			newMessageOpen: false,
			members: [],
			memberExpanded: false,
		}
		autobind(this)
	}

	componentDidMount() {
		//document.title = `${strings.Gig_Pool} | ${strings.Findd_Grandd_Central}`
		MessageCenterStore.on("object_id_change", this.getData)
	}

	componentWillUnmount() {
		AppStateStore.removeListener("object_id_change", this.getData)
	}

	changeEvent() {
		this.setState({
		}, () => this.getData())
	}

	changeGlobalFilter() {
		//HierarchySettingsStore.getGlobalLevelItemFilterId() !== this.state.globalFilterId &&
	}

	getData() {
		api.getMessageGroups(MessageCenterStore.getObjectId()).then((res) => {
			if(MessageCenterStore.getGigPoolId()){
				api.getGigPoolMembers(MessageCenterStore.getGigPoolId()).then((res2) => {
					this.setState({groups: res.data, members: res2.data, loading: false })					
				}); 
			}else{
				this.setState({ loading: false })
			}
		})
	}

	expandMembers(){
		this.setState({memberExpanded: !this.state.memberExpanded})		
	}

	render() {
        return (
            <Drawer
                open={this.props.open}
                openSecondary
                width={1200}
                docked={false}
                overlayStyle={{ zIndex: 1500 }}
                containerStyle={{ zIndex: 1500, overflow: "unset", opacity: open ? 1 : 0, transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}
                onRequestChange={this.props.handleClose}
            >
                <div style={{ padding: 35, backgroundColor: AppStateStore.getDrawerHeaderColor(), textAlign: "center", color: "#ffffff", fontWeight: "normal", fontSize: 25 }}>
                    {MessageCenterStore.getSubTitle()} - {strings.Message_Center} 
                    <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={()=> this.setState({loading: true, groups:[], members:[], memberExpanded: false}, ()=> {this.props.handleClose()})} />
                </div>

				<div style={{padding: 30}}>
					{!this.state.loading && this.state.members && this.state.members.length > 0 &&
						<MessageCenterActions onNewMessageClick={()=> {
							this.setState({newMessageOpen: true})}
						} />
					}	
					{this.state.loading && 
						<div>
							<div className="spinner"><CircularProgress /></div>
						</div>
					}


					{this.state.members && !this.state.loading &&
						<Card data-intercom-target={`menu-message-center-members-Tab`} expanded={this.state.memberExpanded} onExpandChange={this.expandMembers} style={{marginBottom: 15}}>
							<CardHeader title={this.state.members.length  + " " + strings.Gig_Pool_Members} showExpandableButton={true} actAsExpander={true} />
							<CardText expandable>
								<div style={{display: "flex", flexWrap: "wrap" }}>
									{this.state.members.map((item, index)=> 
										<Chip key={index} style={{ margin: 5 }}>
											{item.Name}
										</Chip>							
									)}	
								</div>
							</CardText>
						</Card>
					}

					{!this.state.loading && this.state.groups && this.state.groups.length === 0 &&
						<div style={{width: "100%", textAlign: "center", fontSize: "18px"}}>
							<p>{strings.No_Messages}</p>
						</div>
					}

					{!this.state.loading && this.state.groups && this.state.groups.length > 0 && 
						<MessageCenterGroupsTable groups={this.state.groups} />
					}
				</div>

				<MessageCenterNewMessageDialog 
					newMessageOpen={this.state.newMessageOpen}
					send={(doc) => {
						api.sendGroupMessage(doc)
						this.setState({ newMessageOpen: false })
					}}
					cancel={() => {
						this.setState({ newMessageOpen: false })
					}} 
					members={this.state.members}
					objectId={MessageCenterStore.getObjectId()}
					messageGroupName={MessageCenterStore.getGroupName()}		
					contextDescription={MessageCenterStore.getContextDescription()}		
				/>
            </Drawer>
        )
	}
}